var $461f694986ee63b0$exports = {};
$461f694986ee63b0$exports = {
    "clear": `Jasen`,
    "invalid": `(neveljavno)`,
    "loading": `Nalaganje...`,
    "noResults": `Ni rezultatov`,
    "valid": `(veljavno)`
};


export {$461f694986ee63b0$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
